/**
 * Created by emt on 20.04.2017.
 */
require('./src/angular-daterangepicker.js');

module.exports = 'angularjs.daterangepicker';


//////////////////
// WEBPACK FOOTER
// ./~/angularjs-daterangepicker/index.js
// module id = 292
// module chunks = 0